import { css } from "@emotion/react"
import { forwardRef, useRef } from "react"

import inputStyles from "./inputStyles"
import useUncontrolledAsControlled from "./useUncontrolledAsControlled"

type TextInputProps = {
  hasError?: boolean
  paddingRight?: number
  value?: string
  height?: number
} & Omit<JSX.IntrinsicElements["input"], "value">

const TextInput = forwardRef<HTMLInputElement | null, TextInputProps>(
  ({ hasError = false, paddingRight, value, height, ...restProps }, ref) => {
    const className = css(inputStyles.input, restProps.disabled && inputStyles.disabled, hasError && inputStyles.error)

    const internalRef = useRef<HTMLInputElement | null>(null)
    useUncontrolledAsControlled(internalRef, value)

    return (
      <input
        ref={(instance) => {
          internalRef.current = instance
          if (typeof ref === "function") {
            ref(instance)
          } else if (ref !== null) {
            ref.current = instance
          }
        }}
        type="text"
        {...restProps}
        css={className}
        style={{ paddingRight, height }}
      />
    )
  }
)

export default TextInput
